import { CSSObject } from "@mui/material";

export const globalStyles: CSSObject = {
  "html, body, #root": {
    height: "100vh",
  },
};
